import { CardContent, Grid, ListItem, ListItemText, Typography } from '@mui/material';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { PmiCard } from 'shell/components/shared/card';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import PmiTitle from 'shell/components/shared/title';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { HomePageCohabitationCrumbs } from 'cohabitation/constants/breadcrumb';
import { CohabitationAuthorizations } from 'shell/authorizations/cohabitation';

const HomePage = (): React.ReactElement => {
  const actions = useActionAuthorization({
    ricerca: [CohabitationAuthorizations.CohabitationQuery],
    aggiunta: [CohabitationAuthorizations.CohabitationAdd],
  });

  return (
    <Fragment>
      <Breadcrumbs items={HomePageCohabitationCrumbs} />
      <PmiTitle title="Convivenza" paddingBottom={1} />
      <div className="pmi-mb-4">
        <Typography component="div" fontSize=".9rem" color="primary">
          {"Seleziona l'area su cui iniziare ad operare"}
        </Typography>
      </div>
      <Grid container spacing={2}>
        {actions.ricerca ? (
          <Grid item xs={12} md={4}>
            <Link to="/convivenza/ricerca" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Ricerca Convivenza" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {actions.aggiunta ? (
          <Grid item xs={12} md={4}>
            <Link to="/convivenza/inserimento" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Registrazione Convivenza" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
      </Grid>
    </Fragment>
  );
};

HomePage.displayName = 'home page component';

export default HomePage;
